<div libImaAdContainer></div>
<div class="puzzle-screen" *ngIf="this.initialized && this.iconFontLoaded"
     (click)="appClicked($event)"
     [class.allow-vertical-top-bar]="allowMobileVerticalTopBar"
     [class.is-iframe]="isIframe"
     [class.is-mobile]="isMobile"
>
  <ion-header class="puzzle-screen-header">
    <ion-toolbar class="puzzle-screen-toolbar" [class.remove-side-margins]="removeSideMargins">
      <app-puzzle-button-bar class="puzzle-screen-button-bar" [allowVertical]="allowMobileVerticalTopBar" />
      <div class="puzzle-header-counter-timer" slot="end">
        <lib-app-leaderboard-info class="timer-counter" *ngIf="leaderboard.leaderboardEnabled$ | async" />
        <lib-app-puzzle-move-counter class="timer-counter" *ngIf="showMoveCounter" />
        <lib-app-puzzle-timer class="timer-counter" *ngIf="showTimer" />
      </div>
    </ion-toolbar>
    <lib-app-definition-bar *ngIf="crosswordBoardConfig" [crosswordBoardConfig]="crosswordBoardConfig" />
    <ion-progress-bar [value]="progress" />
  </ion-header>
  <div id="puzzle-screen-main" class="puzzle-screen-main">
    <lib-app-print-info />
    <div id="puzzle-screen-game" class="puzzle-screen-game">
      <div class="puzzle-screen-game-inner">
        <lib-app-crossword-board
          *ngIf="gameType === 'crossword' && !swedishPuzzleLegacy"
          [crosswordBoardConfig]="crosswordBoardConfig"
        />
        <lib-app-image-puzzle-board *ngIf="gameType === 'image'" />
        <lib-app-sudoku-board *ngIf="gameType === 'sudoku'" />
        <lib-app-word-search-puzzle-board *ngIf="gameType === 'word-search'" />
        <lib-app-quiz-board *ngIf="gameType === 'quiz'" />
        <lib-app-hashi-board *ngIf="gameType === 'hashi'" />
      </div>
    </div>
  </div>

  <ion-fab
    class="flip-fab"
    vertical="bottom"
    horizontal="end"
    slot="fixed"
    *ngIf="(puzzleGame && puzzleGame.finished) || cheatCodeEnabled"
  >
    <ion-fab-button
      *ngIf="puzzleGame && puzzleGame.finished"
      (mouseenter)="backToWinMouseOver = true"
      (mouseleave)="backToWinMouseOver = false"
      (click)="showWinDialog(true)"
    >
      <ion-icon [class.visible]="backToWinMouseOver" [class.flipped]="backToWinMouseOver" name="trophy-sharp" />
      <ion-icon
        class="reverse"
        [class.visible]="!backToWinMouseOver"
        [class.flipped]="backToWinMouseOver"
        name="arrow-redo-sharp"
      />
    </ion-fab-button>
    <ion-fab-button
      *ngIf="cheatCodeEnabled && framework.puzzleFileLoadErrors.length"
      (click)="showErrors()"
      color="danger"
    >
      <ion-icon class="visible" name="bug-sharp" />
    </ion-fab-button>
    <ion-fab-button *ngIf="cheatCodeEnabled" (click)="showDeveloperMode()" color="success">
      <ion-icon class="visible" name="code-working" />
    </ion-fab-button>
  </ion-fab>

  <lib-puzzle-landscape-message />

</div>

<div *ngIf="!this.initialized || !this.iconFontLoaded" class="app-loading">
  <div class="app-loading-inner">
    <!-- To keep this, for development, comment out this.initialized = true; on initPuzzleScreen() -->
    <div class="logo"></div>
    <svg class="spinner" viewBox="25 25 50 50" *ngIf="!noPuzzle">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
    </svg>
  </div>
  <ion-list
    lines="none"
    class="error-list"
  >
    <ion-item
      *ngIf="framework.puzzleFileLoadErrors.length && !cheatCodeEnabled"
    >
      <ion-text color="primary" [innerHTML]="'PUZZLE.file_load_error' | translate"/>
    </ion-item>
    <ng-container *ngIf="framework.puzzleFileLoadErrors.length && cheatCodeEnabled" >
      <ion-item class="ion-text-center" *ngFor="let error of framework.puzzleFileLoadErrors">
        <ion-label color="primary">{{ error }}</ion-label>
      </ion-item>
    </ng-container>
  </ion-list>
</div>

